import Vue from "vue";
// 注册
Vue.filter("notAvailable", function(value) {
  // 返回处理后的值
  if (!value) {
    return "暂无";
  }
  return value;
});
Vue.filter("twoPoint", function(value) {
  // 返回处理后的值
  return Number(value).toFixed(2);
});
Vue.filter("cutOut", function(value) {
  // 返回处理后的值
  let result =
    value.length > 16 ? `${value.slice(0, 16)}...` : value.slice(0, 16);
  return result;
});
Vue.filter("formatTime", function(time) {
  if (time !== undefined && time !== "" && time !== null) {
    let date = new Date(parseInt(time));
    return formatDate(date, "yyyy年MM月dd日 hh:mm");
  }

  function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : padLeftZero(str)
        );
      }
    }
    return fmt;
  }

  function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
});

Vue.filter("formatDay", function(time) {
  if (time !== undefined && time !== "" && time !== null) {
    let date = new Date(parseInt(time));
    return formatDate(date, "yyyy-MM-dd");
  }

  function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : padLeftZero(str)
        );
      }
    }
    return fmt;
  }

  function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
});
// 支持数字, 字符串时间, 时间对象, 按照传入格式格式化时间 
Vue.filter("formatByFmt", function(date, fmt) {
  var ret;
  if (typeof date !== "object") {
    if (typeof date === "string" && !isNaN(date)) {
      date = new Date(Number(date));
    } else {
      date = new Date(date);
    }
  }
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "M+": (date.getMonth() + 1).toString(), // 月
    "D+": date.getDate().toString(), // 日
    "h+": date.getHours().toString(), // 时
    "m+": date.getMinutes().toString(), // 分
    "s+": date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
});
// 价钱数字补0过滤器
Vue.filter("formatPrice", function(v) {
  if (v) {
    if (isNaN(v)) {
      return v;
    } else {
      v = Math.round(v * 100) / 100 + "";
      var i = v.indexOf(".");
      if (i < 0) {
        // 没有小数点时：
        i = v.length;
        v += ".00";
      } else {
        while (v.length <= i + 2) {
          v += "0";
        }
      }
      return v;
    }
  } else {
    return "0.00";
  }
});



// WEBPACK FOOTER //
// ./src/projects/zikuPC/main/filter.js